"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var Description = function Description(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/_react.default.createElement("div", null, text);
};
var _default = Description;
exports.default = _default;
Description.propTypes = {
  /**
   * Description text.
   */
  text: _propTypes.default.string
};
Description.defaultProps = {
  text: ''
};